import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    createGenericProductDeductionAndIncrease({ commit, dispatch }, model) {
      return ajax.post("Sales/api/GenericProductDeductionAndIncreases", model);
    },
    createSpecificProductDeductionAndIncrease({ commit, dispatch }, model) {
      return ajax.post("Sales/api/SpecificProductDeductionAndIncreases", model);
    },
    deleteDeductionAndIncreases({ commit, dispatch }, id) {
      return ajax.delete(
        "Sales/api/DeductionAndIncreases",
        { data: { id: id } },
        { headers: { "Content-Type": "application/json" } }
      );
    },
    updateDeductionAndIncrease({ commit, dispatch }, model) {
      return ajax.put("Sales/api/ContractDeductionAndIncrease", model);
    },
    assignGenericProductInfo({ commit, dispatch }, model) {
      return ajax.put(
        "Sales/api/GenericProductDeductionAndIncreases/add",
        model
      );
    },
    unassignGenericProductInfo({ commit, dispatch }, model) {
      return ajax.put(
        "Sales/api/GenericProductDeductionAndIncreases/remove",
        model,
        { headers: { "Content-Type": "application/json" } }
      );
    },
    assignSpecificProductInfo({ commit, dispatch }, model) {
      return ajax.put(
        "Sales/api/SpecificProductDeductionAndIncreases/add",
        model
      );
    },
    unassignSpecificProductInfo(
      { commit, dispatch },
      { contractId, id, genericProductId }
    ) {
      return ajax.put(
        "Sales/api/SpecificProductDeductionAndIncreases/remove",
        {
          data: {
            contractId: contractId,
            id: id,
            genericProductId: genericProductId
          }
        },
        { headers: { "Content-Type": "application/json" } }
      );
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
